<template>
    <div class="ma-6 row-loader">  
        <div class="item-loader"></div>      
    </div>
</template>

<script>

export default {
    name: 'loaderApp',
    data() {
        return {};
    },
    computed: {
 
    },
    methods: {
    },
}
</script>

<style lang="stylus">
    
    .row-loader
        display: flex;
        align-items: center;
        justify-content: center;       

        .item-loader
            background-image: url("/src/assets/images/icons/louder.gif");
            background-size: contain;
            width: 64px;
            height: 64px;

</style>